// extracted by extract-css-chunks-webpack-plugin
module.exports = {"attrs":"attrs_OOH2y","attr":"attr_sczim","attr_label":"attr_label_JeCnu","attr_value":"attr_value_MCSuv","ui_mask":"ui_mask_SZMJY"};